function initializeBulkNotificationForm() {
    const group = document.querySelector("[data-bulk-recipient-group]");
    const emailContainer = document.querySelector("[data-bulk-email-list-container]");
    const emailList = document.querySelector("[data-bulk-email-list]");
    const sendEmail = document.querySelector("[data-bulk-send-email]");
    const requiredMessage = document.querySelector("[data-bulk-email-required-message]");

    if (!group || !emailContainer || !emailList || !sendEmail) return;

    const refresh = () => {
        const usesEmailList = group.value === "email_list";
        emailContainer.classList.toggle("d-none", !usesEmailList);
        emailList.required = usesEmailList;
        requiredMessage?.classList.toggle("d-none", !usesEmailList);

        if (usesEmailList) sendEmail.checked = true;
    };

    group.addEventListener("change", refresh);
    refresh();
}

document.addEventListener("turbolinks:load", initializeBulkNotificationForm);
